module.exports = __webpack_public_path__ + "img/madera008.ecaf2c26.jpg";